import styled from 'styled-components';

export const ContainerScreens = styled.div`
  width: 100%;
  padding: 5px;
`;
